import styled from 'styled-components';
import { Icons } from '@cyberint/dsc';

export const WaterMark = styled.div`
  display: flex;
  align-items: center;
  color: var(--appleGreen);
  font-weight: bold;
  font-size: 30px;
  opacity: 0.5;
  white-space: nowrap;
  position: relative;

  .env-value {
    font-size: 18px;
  }
`;

export const CloseButton = styled(Icons.Close).attrs({ size: 12 })`
  position: absolute;
  top: -2px;
  right: -6px;
  display: none;
  background-color: var(--icon-button-sec-bg-color, var(--timberwolf));
  color: var(--icon-button-sec-color, var(--richBlack2));
  width: 12px;
  height: 12px;
  border-radius: 50%;
  padding: 2px;

  ${WaterMark}:hover & {
    display: unset;
  }
`;
